import { render, staticRenderFns } from "./ExamplePayloadView.vue?vue&type=template&id=44dba11f&scoped=true&"
import script from "./ExamplePayloadView.vue?vue&type=script&lang=js&"
export * from "./ExamplePayloadView.vue?vue&type=script&lang=js&"
import style0 from "./ExamplePayloadView.vue?vue&type=style&index=0&id=44dba11f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dba11f",
  null
  
)

export default component.exports